import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useTranslations } from "next-intl";
import React from "react";

type Props = {
  search: string;
  setSearch: (search: string) => void;
  onSearch?: () => void;
};

const SearchInput: React.FC<Props> = ({ search, setSearch, onSearch }) => {
  const t = useTranslations("search");
  return (
    <div className="relative w-full">
      <Search className="absolute top-1/2 left-3 transform text-muted-foreground size-5 -translate-y-1/2" />
      <Input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={t("input-placeholder")}
        className="pl-10 text-sm sm:text-base"
        onKeyDown={(e) => {
          if (!onSearch) return;

          if (e.key === "Enter") {
            onSearch();
          }
        }}
      />
    </div>
  );
};

export default SearchInput;
